import { FC } from 'react'

import { PrimaryAlert } from 'src/Components/PrimaryAlert'
import { useSubscriptionPackagesQuery } from 'src/Redux/subscriptionPackagesApi'

import { AlertWrapper } from './styles'

export const SubscriptionsError: FC = () => {
  const { isError } = useSubscriptionPackagesQuery()

  if (!isError) {
    return null
  }

  return (
    <AlertWrapper>
      <PrimaryAlert type='danger' hasCross={false}>
        Oops. Something went wrong, please try again later or contact support.
      </PrimaryAlert>
    </AlertWrapper>
  )
}
